/* ========================================================================
 * FD:          number
 * Child:       --
 * Version:     1.0
 * ========================================================================
 * ======================================================================== 
 * 2/22/2016: creation
*/


/* ========================================================================
 *  vars
 * ========================================================================
*/


/* ========================================================================
 *  functions
 * ========================================================================
*/
////  function 
//Number.FN = function (x) {
   
//};




/* ========================================================================
 *  display
 * ========================================================================
*/


//  get precision
//  pass in precision > 0
Number.prototype.getP = function (precision) {
    if (precision === 0) precision = 1;
    return this.toPrecision(precision);
}

